/**
 * A function to create a log object for the 'clickOnContactUsLink' event (evid: 26)
 *
 * @param {clickOnContactUsLinkParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickOnContactUsLinkParams>} LogObject<clickOnContactUsLinkParams>
 */
export function clickOnContactUsLink(params) {
    return { evid: 26, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'contactUsDescribeIssue' event (evid: 527)
 *
 * @param {contactUsDescribeIssueParams} params - The parameters for this event
 * @property {string} first_answer
 * @property {string} lang
 * @property {string} question
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<contactUsDescribeIssueParams>} LogObject<contactUsDescribeIssueParams>
 */
export function contactUsDescribeIssue(params) {
    return { evid: 527, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactRecaptchaWasLoadedInTheRequestACallPage' event (evid: 599)
 *
 * Event description: this event is trigger when the reCAPTCHA is loaded and the logo appears on the bottom of the page
 *
 * @param {wixContactRecaptchaWasLoadedInTheRequestACallPageParams} params - The parameters for this event
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<wixContactRecaptchaWasLoadedInTheRequestACallPageParams>} LogObject<wixContactRecaptchaWasLoadedInTheRequestACallPageParams>
 */
export function wixContactRecaptchaWasLoadedInTheRequestACallPage(params) {
    return { evid: 599, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'hpClickingOnSubCategory' event (evid: 61)
 *
 * @param {hpClickingOnSubCategoryParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<hpClickingOnSubCategoryParams>} LogObject<hpClickingOnSubCategoryParams>
 */
export function hpClickingOnSubCategory(params) {
    return { evid: 61, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationAnsBiCallMeWithTheCode' event (evid: 619)
 *
 * Event description: The user asks for a call for the code
 *
 * @param {smsVerificationAnsBiCallMeWithTheCodeParams} params - The parameters for this event
 * @return {LogObject<smsVerificationAnsBiCallMeWithTheCodeParams>} LogObject<smsVerificationAnsBiCallMeWithTheCodeParams>
 */
export function smsVerificationAnsBiCallMeWithTheCode(params) {
    return { evid: 619, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'playVideo' event (evid: 12)
 *
 * @param {playVideoParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} video
 * @return {LogObject<playVideoParams>} LogObject<playVideoParams>
 */
export function playVideo(params) {
    return { evid: 12, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnTopicChangingProductButton' event (evid: 38)
 *
 * @param {clickingOnTopicChangingProductButtonParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} topic_title
 * @return {LogObject<clickingOnTopicChangingProductButtonParams>} LogObject<clickingOnTopicChangingProductButtonParams>
 */
export function clickingOnTopicChangingProductButton(params) {
    return { evid: 38, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickIHaveAnotherIssueButton' event (evid: 533)
 *
 * @param {clickIHaveAnotherIssueButtonParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<clickIHaveAnotherIssueButtonParams>} LogObject<clickIHaveAnotherIssueButtonParams>
 */
export function clickIHaveAnotherIssueButton(params) {
    return { evid: 533, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationAnsBiCodeSubmitted' event (evid: 615)
 *
 * Event description: The user successfully submits the code sent to their phone
 *
 * @param {smsVerificationAnsBiCodeSubmittedParams} params - The parameters for this event
 * @return {LogObject<smsVerificationAnsBiCodeSubmittedParams>} LogObject<smsVerificationAnsBiCodeSubmittedParams>
 */
export function smsVerificationAnsBiCodeSubmitted(params) {
    return { evid: 615, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'postNewTopicSelectingSearchResult' event (evid: 68)
 *
 * @param {postNewTopicSelectingSearchResultParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<postNewTopicSelectingSearchResultParams>} LogObject<postNewTopicSelectingSearchResultParams>
 */
export function postNewTopicSelectingSearchResult(params) {
    return { evid: 68, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'choosingASearchResult' event (evid: 54)
 *
 * @param {choosingASearchResultParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} title
 * @property {string} item
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<choosingASearchResultParams>} LogObject<choosingASearchResultParams>
 */
export function choosingASearchResult(params) {
    return { evid: 54, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'editCall' event (evid: 545)
 *
 * Event description: click the 'Change Phone Number' button or 'Change Schedule' button from the phone ticket page
 *
 * @param {editCallParams} params - The parameters for this event
 * @property {string} action - change phone number\change schedule
 * @property {string} category - the subcategory the user selected
 * @property {number} eta - the estimated wait time presented to the user
 * @property {string} issue_id - unique identifier of phone ticket
 * @property {GUID} item_id - ticket id
 * @property {string} item_name - the title that user provided
 * @property {string} lang
 * @property {string} phone - phone number submitted by the user
 * @property {string} referral_name
 * @property {string} time_slot - time slot selected by the user
 * @property {string} type - question\bug\wishlist
 * @return {LogObject<editCallParams>} LogObject<editCallParams>
 */
export function editCall(params) {
    return { evid: 545, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistClickOnRequestCallback' event (evid: 564)
 *
 * Event description: Clicking the "Request Callback" button
 *
 * @param {quickAssistClickOnRequestCallbackParams} params - The parameters for this event
 * @property {string} block_id - the id of the selected block
 * @property {string} block_name - the name of the selected block
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} channel - channel the users came from
 * @property {string} content_id - the id of the selected content
 * @property {string} content_name - the name of the selected content
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} source_name - location of the button
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<quickAssistClickOnRequestCallbackParams>} LogObject<quickAssistClickOnRequestCallbackParams>
 */
export function quickAssistClickOnRequestCallback(params) {
    return { evid: 564, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'choosingASearchResultSrc4Evid53' event (evid: 53)
 *
 * @param {choosingASearchResultSrc4Evid53Params} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} title
 * @property {string} item
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} type
 * @return {LogObject<choosingASearchResultSrc4Evid53Params>} LogObject<choosingASearchResultSrc4Evid53Params>
 */
export function choosingASearchResultSrc4Evid53(params) {
    return { evid: 53, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistContentBlockClick' event (evid: 562)
 *
 * Event description: Clicking on a content item inside a Block
 *
 * @param {quickAssistContentBlockClickParams} params - The parameters for this event
 * @property {string} block_id - the id of the selected block
 * @property {string} block_name - the name of the selected block
 * @property {string} channel - channel the users came from
 * @property {string} content_id - the id of the selected content
 * @property {string} content_name - the name of the selected content
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @return {LogObject<quickAssistContentBlockClickParams>} LogObject<quickAssistContentBlockClickParams>
 */
export function quickAssistContentBlockClick(params) {
    return { evid: 562, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'accountAccessTicketSubmissionSuccess' event (evid: 651)
 *
 * Event description: User was able to submit a ticket through "Account Recovery"
 *
 * @param {accountAccessTicketSubmissionSuccessParams} params - The parameters for this event
 * @property {string} lang - lang
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {GUID} ticket_id - ticket_id
 * @property {string} ticket_url - ticket_url
 * @return {LogObject<accountAccessTicketSubmissionSuccessParams>} LogObject<accountAccessTicketSubmissionSuccessParams>
 */
export function accountAccessTicketSubmissionSuccess(params) {
    return { evid: 651, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'accountAccessTicketSubmissionFailed' event (evid: 652)
 *
 * Event description: User was not able to submit a ticket through "Wix Contact"
 *
 * @param {accountAccessTicketSubmissionFailedParams} params - The parameters for this event
 * @property {string} lang - answers language
 * @property {string} reason - reason for ticket tubmission fail
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @return {LogObject<accountAccessTicketSubmissionFailedParams>} LogObject<accountAccessTicketSubmissionFailedParams>
 */
export function accountAccessTicketSubmissionFailed(params) {
    return { evid: 652, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickScheduleCall' event (evid: 544)
 *
 * Event description: click 'schedule call' on the 'schedule a call with wix support' page
 *
 * @param {clickScheduleCallParams} params - The parameters for this event
 * @property {string} category - the subcategory the user selected
 * @property {number} eta - the estimated wait time presented to the user
 * @property {string} issue_id - unique identifier of phone ticket
 * @property {GUID} item_id - ticket id
 * @property {string} item_name - the title that user provided
 * @property {string} lang
 * @property {string} phone - phone number submitted by the user
 * @property {string} referral_name
 * @property {string} source_name - the page they clicked the button on
 * @property {Url} source_url - the page they clicked the button on
 * @property {string} time_slot - time slot selected by the user
 * @property {string} type - question\bug\wishlist
 * @return {LogObject<clickScheduleCallParams>} LogObject<clickScheduleCallParams>
 */
export function clickScheduleCall(params) {
    return { evid: 544, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationAnsBiCodeSubmissionError' event (evid: 616)
 *
 * Event description: The user submits an incorrect code
 *
 * @param {smsVerificationAnsBiCodeSubmissionErrorParams} params - The parameters for this event
 * @return {LogObject<smsVerificationAnsBiCodeSubmissionErrorParams>} LogObject<smsVerificationAnsBiCodeSubmissionErrorParams>
 */
export function smsVerificationAnsBiCodeSubmissionError(params) {
    return { evid: 616, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnCategoryOnHomePage' event (evid: 10)
 *
 * @param {clickingOnCategoryOnHomePageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnCategoryOnHomePageParams>} LogObject<clickingOnCategoryOnHomePageParams>
 */
export function clickingOnCategoryOnHomePage(params) {
    return { evid: 10, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistContactUsCanceled' event (evid: 568)
 *
 * Event description: User left the "Contact Us" flow  (click on the X button, "No Thanks" button, etc.)
 *
 * @param {quickAssistContactUsCanceledParams} params - The parameters for this event
 * @property {string} block_id - the id of the selected block
 * @property {string} block_name - the name of the selected block
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} channel - channel the users came from
 * @property {string} content_id - the id of the selected content
 * @property {string} content_name - the name of the selected content
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} source_name - "contact us" screen, "callback" screen, "ticket" screen, etc.
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<quickAssistContactUsCanceledParams>} LogObject<quickAssistContactUsCanceledParams>
 */
export function quickAssistContactUsCanceled(params) {
    return { evid: 568, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistCallbackFailed' event (evid: 567)
 *
 * Event description: User was not able to schedule a callback
 *
 * @param {quickAssistCallbackFailedParams} params - The parameters for this event
 * @property {string} block_id - the id of the selected block
 * @property {string} block_name - the name of the selected block
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} channel - channel the users came from
 * @property {string} content_id - the id of the selected content
 * @property {string} content_name - the name of the selected content
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} reason - reason for callback fail
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<quickAssistCallbackFailedParams>} LogObject<quickAssistCallbackFailedParams>
 */
export function quickAssistCallbackFailed(params) {
    return { evid: 567, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'postNewTopicClickingOnPostButton' event (evid: 69)
 *
 * @param {postNewTopicClickingOnPostButtonParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} title
 * @property {string} type
 * @property {string} url
 * @return {LogObject<postNewTopicClickingOnPostButtonParams>} LogObject<postNewTopicClickingOnPostButtonParams>
 */
export function postNewTopicClickingOnPostButton(params) {
    return { evid: 69, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'followTopic' event (evid: 72)
 *
 * @param {followTopicParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<followTopicParams>} LogObject<followTopicParams>
 */
export function followTopic(params) {
    return { evid: 72, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnSubmitForEmailUsForm' event (evid: 36)
 *
 * @param {clickingOnSubmitForEmailUsFormParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} title
 * @return {LogObject<clickingOnSubmitForEmailUsFormParams>} LogObject<clickingOnSubmitForEmailUsFormParams>
 */
export function clickingOnSubmitForEmailUsForm(params) {
    return { evid: 36, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnEmailUsLink' event (evid: 35)
 *
 * @param {clickingOnEmailUsLinkParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnEmailUsLinkParams>} LogObject<clickingOnEmailUsLinkParams>
 */
export function clickingOnEmailUsLink(params) {
    return { evid: 35, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'forumSearchClickedOutsideBox' event (evid: 549)
 *
 * Event description: user clicked outside box after using the search in the forum page
 *
 * @param {forumSearchClickedOutsideBoxParams} params - The parameters for this event
 * @property {string} first_answer - first answer user receives
 * @property {string} lang
 * @property {string} question - question submitted by the user
 * @property {string} referral_name
 * @property {string} source_name - source page name
 * @property {string} source_url - source page url
 * @return {LogObject<forumSearchClickedOutsideBoxParams>} LogObject<forumSearchClickedOutsideBoxParams>
 */
export function forumSearchClickedOutsideBox(params) {
    return { evid: 549, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheVideoLessonsButton' event (evid: 513)
 *
 * @param {clickTheVideoLessonsButtonParams} params - The parameters for this event
 * @property {string} item_name
 * @property {string} item_url
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<clickTheVideoLessonsButtonParams>} LogObject<clickTheVideoLessonsButtonParams>
 */
export function clickTheVideoLessonsButton(params) {
    return { evid: 513, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnPostQuestionOpenForm' event (evid: 7)
 *
 * @param {clickOnPostQuestionOpenFormParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickOnPostQuestionOpenFormParams>} LogObject<clickOnPostQuestionOpenFormParams>
 */
export function clickOnPostQuestionOpenForm(params) {
    return { evid: 7, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnNeedMoreHelpInEditorHelpCenter' event (evid: 59)
 *
 * @param {clickingOnNeedMoreHelpInEditorHelpCenterParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} path
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnNeedMoreHelpInEditorHelpCenterParams>} LogObject<clickingOnNeedMoreHelpInEditorHelpCenterParams>
 */
export function clickingOnNeedMoreHelpInEditorHelpCenter(params) {
    return { evid: 59, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnPostButton' event (evid: 33)
 *
 * @param {clickingOnPostButtonParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} title
 * @property {string} type
 * @property {string} url
 * @return {LogObject<clickingOnPostButtonParams>} LogObject<clickingOnPostButtonParams>
 */
export function clickingOnPostButton(params) {
    return { evid: 33, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'contactUsSelectIssue' event (evid: 526)
 *
 * @param {contactUsSelectIssueParams} params - The parameters for this event
 * @property {string} category
 * @property {string} first_answer
 * @property {string} item_name
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<contactUsSelectIssueParams>} LogObject<contactUsSelectIssueParams>
 */
export function contactUsSelectIssue(params) {
    return { evid: 526, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'generalAnswersFedEvent' event (evid: 707)
 *
 * Event description: This is a general event that serves as "event candidate". Relevant events will be later developed as standalone events.
 *
 * @param {generalAnswersFedEventParams} params - The parameters for this event
 * @property {GUID} agent_id - the answers id of the agent
 * @property {string} data - data
 * @property {boolean} is_loading_successful - DEPRECATED
 * @property {GUID} tenant_id - tenant
 * @property {GUID} ticket_id - the id of the ticket (thread)
 * @property {string} type - the type of the event, for example: click on ASK
 * @return {LogObject<generalAnswersFedEventParams>} LogObject<generalAnswersFedEventParams>
 */
export function generalAnswersFedEvent(params) {
    return { evid: 707, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'ticketOrUserReplyCreated' event (evid: 701)
 *
 * Event description: A UGC (ticket or user's reply) was created in Wix's tennant. This event is only for Real Time and is not stored (only collected).
 *
 * @param {ticketOrUserReplyCreatedParams} params - The parameters for this event
 * @return {LogObject<ticketOrUserReplyCreatedParams>} LogObject<ticketOrUserReplyCreatedParams>
 */
export function ticketOrUserReplyCreated(params) {
    return { evid: 701, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactOpenChatFailedClient' event (evid: 598)
 *
 * Event description: User was not able to open a chat conversation
 *
 * @param {wixContactOpenChatFailedClientParams} params - The parameters for this event
 * @property {Url} action_url - the url of the suggested action button, next to the solution content
 * @property {string} announcement_text - announcement that is shown to user
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} chatbot_view - Widget, fullscreen, etc.
 * @property {GUID} chatid - answers chat guid
 * @property {string} context - base on which platform the event is trigger { Contact form,Direct}
 * @property {string} conversation_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} live_chat_group - reason the user is seeing the live chat option
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} previous_node_id
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<wixContactOpenChatFailedClientParams>} LogObject<wixContactOpenChatFailedClientParams>
 */
export function wixContactOpenChatFailedClient(params) {
    return { evid: 598, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'recaptchaTryFailed' event (evid: 553)
 *
 * Event description: user failed to enter the correct captcha
 *
 * @param {recaptchaTryFailedParams} params - The parameters for this event
 * @property {string} lang - support language
 * @property {string} referral_name
 * @property {GUID} session_id - a unique guid for submit ticket flow
 * @property {string} source_name - source page name (kb,forum, etc.)
 * @property {string} source_url - source page url
 * @property {string} type - type of captcha (audio, text, photos)
 * @return {LogObject<recaptchaTryFailedParams>} LogObject<recaptchaTryFailedParams>
 */
export function recaptchaTryFailed(params) {
    return { evid: 553, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnGoInSerachBoxInCategoryPage' event (evid: 58)
 *
 * @param {clickingOnGoInSerachBoxInCategoryPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} title
 * @property {string} item
 * @property {string} path
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} type
 * @return {LogObject<clickingOnGoInSerachBoxInCategoryPageParams>} LogObject<clickingOnGoInSerachBoxInCategoryPageParams>
 */
export function clickingOnGoInSerachBoxInCategoryPage(params) {
    return { evid: 58, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'contactUsClickOnAnswer' event (evid: 528)
 *
 * @param {contactUsClickOnAnswerParams} params - The parameters for this event
 * @property {string} answer
 * @property {number} index
 * @property {string} lang
 * @property {string} question
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<contactUsClickOnAnswerParams>} LogObject<contactUsClickOnAnswerParams>
 */
export function contactUsClickOnAnswer(params) {
    return { evid: 528, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistCallbackSuccess' event (evid: 566)
 *
 * Event description: User was able to schedule a callback
 *
 * @param {quickAssistCallbackSuccessParams} params - The parameters for this event
 * @property {string} block_id - the id of the selected block
 * @property {string} block_name - the name of the selected block
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} channel - channel the users came from
 * @property {number} clid - the call id that was created in WCC
 * @property {string} content_id - the id of the selected content
 * @property {string} content_name - the name of the selected content
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<quickAssistCallbackSuccessParams>} LogObject<quickAssistCallbackSuccessParams>
 */
export function quickAssistCallbackSuccess(params) {
    return { evid: 566, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickATab' event (evid: 506)
 *
 * @param {clickATabParams} params - The parameters for this event
 * @property {string} item_name
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<clickATabParams>} LogObject<clickATabParams>
 */
export function clickATab(params) {
    return { evid: 506, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationAnsBiExitOutOfCodeSubmissionForm' event (evid: 620)
 *
 * Event description: The user exits out of the form for code submission
 *
 * @param {smsVerificationAnsBiExitOutOfCodeSubmissionFormParams} params - The parameters for this event
 * @return {LogObject<smsVerificationAnsBiExitOutOfCodeSubmissionFormParams>} LogObject<smsVerificationAnsBiExitOutOfCodeSubmissionFormParams>
 */
export function smsVerificationAnsBiExitOutOfCodeSubmissionForm(params) {
    return { evid: 620, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactAnnouncementClicked' event (evid: 587)
 *
 * Event description: Announcement was clicked
 *
 * @param {wixContactAnnouncementClickedParams} params - The parameters for this event
 * @property {string} announcement_text - the announcement that is shows to users
 * @property {string} lang - answers language
 * @return {LogObject<wixContactAnnouncementClickedParams>} LogObject<wixContactAnnouncementClickedParams>
 */
export function wixContactAnnouncementClicked(params) {
    return { evid: 587, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickSearchFirstAnswerDisplayed' event (evid: 64)
 *
 * @param {quickSearchFirstAnswerDisplayedParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<quickSearchFirstAnswerDisplayedParams>} LogObject<quickSearchFirstAnswerDisplayedParams>
 */
export function quickSearchFirstAnswerDisplayed(params) {
    return { evid: 64, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactUserEnterToRequestCallbackPage' event (evid: 602)
 *
 * Event description: "Request Callback" page is appear
 *
 * @param {wixContactUserEnterToRequestCallbackPageParams} params - The parameters for this event
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {string} context - base on which platform the event is trigger { Contact form,Direct}
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} intent_name - who trigger the page view (automatic,user)
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<wixContactUserEnterToRequestCallbackPageParams>} LogObject<wixContactUserEnterToRequestCallbackPageParams>
 */
export function wixContactUserEnterToRequestCallbackPage(params) {
    return { evid: 602, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'appAgentReply' event (evid: 552)
 *
 * Event description: Agent replies to a user via Answers App
 *
 * @param {appAgentReplyParams} params - The parameters for this event
 * @property {string} lang - answers languages
 * @property {string} referral_name
 * @return {LogObject<appAgentReplyParams>} LogObject<appAgentReplyParams>
 */
export function appAgentReply(params) {
    return { evid: 552, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'askingQuestion' event (evid: 1)
 *
 * Event description: test
 *
 * @param {askingQuestionParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} bug_notice
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<askingQuestionParams>} LogObject<askingQuestionParams>
 */
export function askingQuestion(params) {
    return { evid: 1, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixWidgetChatWasSuccessfullyCreated' event (evid: 664)
 *
 * Event description: the event is trigger when a user requests a chat
 *
 * @param {wixWidgetChatWasSuccessfullyCreatedParams} params - The parameters for this event
 * @property {string} current_platform - current_platform - where that chat is opened from currently { Editor, Biz manager, Domain page .... }
 * @property {string} lang - Answer's lang
 * @property {string} open_method - open method (api,click)
 * @property {string} parent_name - where the widget is opened from (source page name)
 * @property {string} parent_url
 * @property {string} referral_name
 * @property {Url} referral_url - where the widget is opened from
 * @property {string} source_name - source name
 * @property {GUID} ticket_id - ticket id
 * @return {LogObject<wixWidgetChatWasSuccessfullyCreatedParams>} LogObject<wixWidgetChatWasSuccessfullyCreatedParams>
 */
export function wixWidgetChatWasSuccessfullyCreated(params) {
    return { evid: 664, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistSubmitCallbackForm' event (evid: 565)
 *
 * Event description: Clicking the "Request Callback" button at the bottom of the callback form
 *
 * @param {quickAssistSubmitCallbackFormParams} params - The parameters for this event
 * @property {string} block_id - the id of the selected block
 * @property {string} block_name - the name of the selected block
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} channel - channel the users came from
 * @property {string} content_id - the id of the selected content
 * @property {string} content_name - the name of the selected content
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<quickAssistSubmitCallbackFormParams>} LogObject<quickAssistSubmitCallbackFormParams>
 */
export function quickAssistSubmitCallbackForm(params) {
    return { evid: 565, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickALinkInsideArticle' event (evid: 557)
 *
 * Event description: Event created for Dina in order to track how many users click a specific link in an article they are about to distribute to their users
 *
 * @param {clickALinkInsideArticleParams} params - The parameters for this event
 * @property {string} item_name - id of the viewed item
 * @property {string} item_url - url of the viewed item
 * @property {string} link_url - the link the user clicked on
 * @property {string} referral_name
 * @return {LogObject<clickALinkInsideArticleParams>} LogObject<clickALinkInsideArticleParams>
 */
export function clickALinkInsideArticle(params) {
    return { evid: 557, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'forumSearchGotNoAnswer' event (evid: 550)
 *
 * Event description: got no answer when using the forum search
 *
 * @param {forumSearchGotNoAnswerParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} question - question submitted by the user
 * @property {string} referral_name
 * @property {string} source_name - source page name
 * @property {string} source_url - source page url
 * @return {LogObject<forumSearchGotNoAnswerParams>} LogObject<forumSearchGotNoAnswerParams>
 */
export function forumSearchGotNoAnswer(params) {
    return { evid: 550, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickCancelCallButton' event (evid: 542)
 *
 * Event description: clicking the 'cancel call' button
 *
 * @param {clickCancelCallButtonParams} params - The parameters for this event
 * @property {string} call_type - phone call options: scheduled a call \ call now
 * @property {string} category - the subcategory the user selected
 * @property {number} eta - the estimated wait time presented to the user
 * @property {string} issue_id - unique identifier of phone ticket
 * @property {GUID} item_id - ticket id
 * @property {string} item_name - the title that user provided
 * @property {string} lang
 * @property {string} phone - phone number submitted by the user
 * @property {string} referral_name
 * @property {string} type - question\bug\wishlist
 * @return {LogObject<clickCancelCallButtonParams>} LogObject<clickCancelCallButtonParams>
 */
export function clickCancelCallButton(params) {
    return { evid: 542, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'hpClickingOnCategory' event (evid: 60)
 *
 * @param {hpClickingOnCategoryParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<hpClickingOnCategoryParams>} LogObject<hpClickingOnCategoryParams>
 */
export function hpClickingOnCategory(params) {
    return { evid: 60, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'chooseSubCategory' event (evid: 4)
 *
 * @param {chooseSubCategoryParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} wixLanguage - user locale + country name, for example, en-US (from a cookie)
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<chooseSubCategoryParams>} LogObject<chooseSubCategoryParams>
 */
export function chooseSubCategory(params) {
    return { evid: 4, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'oldContactFormTicketSubmissionFailed' event (evid: 591)
 *
 * Event description: User was not able to submit a ticket through the old contact form
 *
 * @param {oldContactFormTicketSubmissionFailedParams} params - The parameters for this event
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} reason - reason for ticket tubmission fail
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} topic - the topic/assign group of the ticket
 * @return {LogObject<oldContactFormTicketSubmissionFailedParams>} LogObject<oldContactFormTicketSubmissionFailedParams>
 */
export function oldContactFormTicketSubmissionFailed(params) {
    return { evid: 591, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnSidebarBannerChangeProduct' event (evid: 37)
 *
 * @param {clickingOnSidebarBannerChangeProductParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<clickingOnSidebarBannerChangeProductParams>} LogObject<clickingOnSidebarBannerChangeProductParams>
 */
export function clickingOnSidebarBannerChangeProduct(params) {
    return { evid: 37, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheReadMoreInAllResultsPage' event (evid: 523)
 *
 * @param {clickTheReadMoreInAllResultsPageParams} params - The parameters for this event
 * @property {string} item_name
 * @property {string} item_url
 * @property {string} lang
 * @property {string} order
 * @property {string} question - the question the user searched for before getting to this page
 * @property {string} referral_name
 * @property {string} source_name
 * @property {string} source_url
 * @return {LogObject<clickTheReadMoreInAllResultsPageParams>} LogObject<clickTheReadMoreInAllResultsPageParams>
 */
export function clickTheReadMoreInAllResultsPage(params) {
    return { evid: 523, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactClickOnBanner' event (evid: 593)
 *
 * Event description: Clicking the "Get Started" button on the banner
 *
 * @param {wixContactClickOnBannerParams} params - The parameters for this event
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {Url} banner_target_url - The button link url
 * @property {string} banner_title - banner's content title (in case changing)
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<wixContactClickOnBannerParams>} LogObject<wixContactClickOnBannerParams>
 */
export function wixContactClickOnBanner(params) {
    return { evid: 593, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'oldContactFormTicketSubmissionSuccess' event (evid: 590)
 *
 * Event description: User was able to submit a ticket through the old contact form
 *
 * @param {oldContactFormTicketSubmissionSuccessParams} params - The parameters for this event
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticket_id - the id of the created ticket
 * @property {string} ticket_url - the url of the created ticket
 * @property {string} topic - the topic/assign group of the ticket
 * @return {LogObject<oldContactFormTicketSubmissionSuccessParams>} LogObject<oldContactFormTicketSubmissionSuccessParams>
 */
export function oldContactFormTicketSubmissionSuccess(params) {
    return { evid: 590, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactAnnouncementToggledOff' event (evid: 586)
 *
 * Event description: Announcement on the current issue has been toggled off
 *
 * @param {wixContactAnnouncementToggledOffParams} params - The parameters for this event
 * @property {string} announcement_text - the announcement that is shows to users
 * @property {string} lang - answers language
 * @return {LogObject<wixContactAnnouncementToggledOffParams>} LogObject<wixContactAnnouncementToggledOffParams>
 */
export function wixContactAnnouncementToggledOff(params) {
    return { evid: 586, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'forumUsePagination' event (evid: 551)
 *
 * Event description: used the pagination in the forum page
 *
 * @param {forumUsePaginationParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @return {LogObject<forumUsePaginationParams>} LogObject<forumUsePaginationParams>
 */
export function forumUsePagination(params) {
    return { evid: 551, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactClickOnSubmitTicket' event (evid: 576)
 *
 * Event description: Clicking the "Submit Ticket" button
 *
 * @param {wixContactClickOnSubmitTicketParams} params - The parameters for this event
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {string} context - base on which platform the event is trigger { Contact form,Direct}
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<wixContactClickOnSubmitTicketParams>} LogObject<wixContactClickOnSubmitTicketParams>
 */
export function wixContactClickOnSubmitTicket(params) {
    return { evid: 576, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnATicket' event (evid: 518)
 *
 * @param {clickOnATicketParams} params - The parameters for this event
 * @property {string} category
 * @property {string} item_name
 * @property {string} item_url
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @property {string} source_url
 * @property {string} sub_category
 * @return {LogObject<clickOnATicketParams>} LogObject<clickOnATicketParams>
 */
export function clickOnATicket(params) {
    return { evid: 518, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistClickOnSubmitTicket' event (evid: 563)
 *
 * Event description: Clicking the "Submit TIcket" button
 *
 * @param {quickAssistClickOnSubmitTicketParams} params - The parameters for this event
 * @property {string} block_id - the id of the selected block
 * @property {string} block_name - the name of the selected block
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} channel - channel the users came from
 * @property {string} content_id - the id of the selected content
 * @property {string} content_name - the name of the selected content
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} source_name - location of the button ("Contact Us", "Callback failed", "already requested callback")
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<quickAssistClickOnSubmitTicketParams>} LogObject<quickAssistClickOnSubmitTicketParams>
 */
export function quickAssistClickOnSubmitTicket(params) {
    return { evid: 563, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnGoInSerachBoxMainPage' event (evid: 52)
 *
 * @param {clickingOnGoInSerachBoxMainPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnGoInSerachBoxMainPageParams>} LogObject<clickingOnGoInSerachBoxMainPageParams>
 */
export function clickingOnGoInSerachBoxMainPage(params) {
    return { evid: 52, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'selectACategory' event (evid: 507)
 *
 * @param {selectACategoryParams} params - The parameters for this event
 * @property {string} category
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @property {string} sub_category
 * @return {LogObject<selectACategoryParams>} LogObject<selectACategoryParams>
 */
export function selectACategory(params) {
    return { evid: 507, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnReadMoreInFaq' event (evid: 57)
 *
 * @param {clickingOnReadMoreInFaqParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} path
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnReadMoreInFaqParams>} LogObject<clickingOnReadMoreInFaqParams>
 */
export function clickingOnReadMoreInFaq(params) {
    return { evid: 57, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'loginClickingEmailUs' event (evid: 71)
 *
 * @param {loginClickingEmailUsParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<loginClickingEmailUsParams>} LogObject<loginClickingEmailUsParams>
 */
export function loginClickingEmailUs(params) {
    return { evid: 71, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickSearchQuestionEntered' event (evid: 63)
 *
 * @param {quickSearchQuestionEnteredParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<quickSearchQuestionEnteredParams>} LogObject<quickSearchQuestionEnteredParams>
 */
export function quickSearchQuestionEntered(params) {
    return { evid: 63, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnLearningCenterLink' event (evid: 6)
 *
 * @param {clickOnLearningCenterLinkParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} link
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {Url} url
 * @return {LogObject<clickOnLearningCenterLinkParams>} LogObject<clickOnLearningCenterLinkParams>
 */
export function clickOnLearningCenterLink(params) {
    return { evid: 6, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationAnsBiMessageSent' event (evid: 613)
 *
 * Event description: The verification message is sent to the phone number entered by the user.
 *
 * @param {smsVerificationAnsBiMessageSentParams} params - The parameters for this event
 * @return {LogObject<smsVerificationAnsBiMessageSentParams>} LogObject<smsVerificationAnsBiMessageSentParams>
 */
export function smsVerificationAnsBiMessageSent(params) {
    return { evid: 613, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'replyATicket' event (evid: 508)
 *
 * @param {replyATicketParams} params - The parameters for this event
 * @property {boolean} is_thread_creator
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<replyATicketParams>} LogObject<replyATicketParams>
 */
export function replyATicket(params) {
    return { evid: 508, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnMenuItem' event (evid: 20)
 *
 * @param {clickOnMenuItemParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} item
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<clickOnMenuItemParams>} LogObject<clickOnMenuItemParams>
 */
export function clickOnMenuItem(params) {
    return { evid: 20, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactClickToContactButton' event (evid: 595)
 *
 * Event description: Clicking the "Click to Contact" button after the 3rd section of the contact page
 *
 * @param {wixContactClickToContactButtonParams} params - The parameters for this event
 * @property {string} button_text - currently: "Click to Contact"
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<wixContactClickToContactButtonParams>} LogObject<wixContactClickToContactButtonParams>
 */
export function wixContactClickToContactButton(params) {
    return { evid: 595, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnAnswersBanner' event (evid: 13)
 *
 * @param {clickingOnAnswersBannerParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnAnswersBannerParams>} LogObject<clickingOnAnswersBannerParams>
 */
export function clickingOnAnswersBanner(params) {
    return { evid: 13, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnContinueButton' event (evid: 5)
 *
 * @param {clickOnContinueButtonParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickOnContinueButtonParams>} LogObject<clickOnContinueButtonParams>
 */
export function clickOnContinueButton(params) {
    return { evid: 5, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickSearchClickingMoreResults' event (evid: 66)
 *
 * @param {quickSearchClickingMoreResultsParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<quickSearchClickingMoreResultsParams>} LogObject<quickSearchClickingMoreResultsParams>
 */
export function quickSearchClickingMoreResults(params) {
    return { evid: 66, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'forumSearchAskingAQuestion' event (evid: 546)
 *
 * Event description: ask a question in the forum search
 *
 * @param {forumSearchAskingAQuestionParams} params - The parameters for this event
 * @property {string} first_answer - first answer user receives
 * @property {string} lang
 * @property {string} question - question submitted by the user
 * @property {string} referral_name
 * @property {string} source_name - source page name
 * @property {string} source_url - source page url
 * @return {LogObject<forumSearchAskingAQuestionParams>} LogObject<forumSearchAskingAQuestionParams>
 */
export function forumSearchAskingAQuestion(params) {
    return { evid: 546, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnTutorialInThirdPage' event (evid: 55)
 *
 * @param {clickingOnTutorialInThirdPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} item
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} title
 * @return {LogObject<clickingOnTutorialInThirdPageParams>} LogObject<clickingOnTutorialInThirdPageParams>
 */
export function clickingOnTutorialInThirdPage(params) {
    return { evid: 55, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'accountAccessSubmitTicketForm' event (evid: 650)
 *
 * Event description: Clicking the "Submit a ticket" button at the bottom of the ticket form
 *
 * @param {accountAccessSubmitTicketFormParams} params - The parameters for this event
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @return {LogObject<accountAccessSubmitTicketFormParams>} LogObject<accountAccessSubmitTicketFormParams>
 */
export function accountAccessSubmitTicketForm(params) {
    return { evid: 650, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickSearchAnswerSelectedByUser' event (evid: 65)
 *
 * @param {quickSearchAnswerSelectedByUserParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<quickSearchAnswerSelectedByUserParams>} LogObject<quickSearchAnswerSelectedByUserParams>
 */
export function quickSearchAnswerSelectedByUser(params) {
    return { evid: 65, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistBlockClick' event (evid: 560)
 *
 * Event description: clicking on a block in the troubleshooter menu
 *
 * @param {quickAssistBlockClickParams} params - The parameters for this event
 * @property {string} block_id - the id of the selected block
 * @property {string} block_name - the name of the selected block
 * @property {string} channel - channel the users came from
 * @property {number} clid - call id of the user that reach the TS from sms link sent to him
 * @property {boolean} contact_toggle - 1- contact option available from every block . 0- contact option available only after clicking 'wasn't helpful' and from 'get help with a different problem'
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @return {LogObject<quickAssistBlockClickParams>} LogObject<quickAssistBlockClickParams>
 */
export function quickAssistBlockClick(params) {
    return { evid: 560, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'searchAbtest' event (evid: 27)
 *
 * @param {searchAbtestParams} params - The parameters for this event
 * @property {string} ablabel
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<searchAbtestParams>} LogObject<searchAbtestParams>
 */
export function searchAbtest(params) {
    return { evid: 27, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactOpenWixContactFromMobile' event (evid: 583)
 *
 * Event description: User opens "Wix Contact" from a mobile device
 *
 * @param {wixContactOpenWixContactFromMobileParams} params - The parameters for this event
 * @property {string} lang - answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @return {LogObject<wixContactOpenWixContactFromMobileParams>} LogObject<wixContactOpenWixContactFromMobileParams>
 */
export function wixContactOpenWixContactFromMobile(params) {
    return { evid: 583, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheSumbitATicketOpenFormLink' event (evid: 516)
 *
 * @param {clickTheSumbitATicketOpenFormLinkParams} params - The parameters for this event
 * @property {string} item_name
 * @property {string} item_url
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<clickTheSumbitATicketOpenFormLinkParams>} LogObject<clickTheSumbitATicketOpenFormLinkParams>
 */
export function clickTheSumbitATicketOpenFormLink(params) {
    return { evid: 516, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactSelectSubOption' event (evid: 572)
 *
 * Event description: User selects a sub option from the dropdown list in "Step 2"
 *
 * @param {wixContactSelectSubOptionParams} params - The parameters for this event
 * @property {string} lang - answers language
 * @property {string} level - the level of the sub option in the sub option flow
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {boolean} solution - does the sub option has a solution
 * @property {string} sub_option_id - the id of the selected sub option
 * @property {string} sub_option_name - the name of the selected sub option
 * @return {LogObject<wixContactSelectSubOptionParams>} LogObject<wixContactSelectSubOptionParams>
 */
export function wixContactSelectSubOption(params) {
    return { evid: 572, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnAPictureWithinTheArticle' event (evid: 627)
 *
 * Event description: Fires once the user clicks a picture that has a link. The event indicates what's the article_id the click came from and what object/picture was clicked on (based on the id of the object/picture). Event was created specifically for the KB Adaptation POC
 *
 * @param {clickOnAPictureWithinTheArticleParams} params - The parameters for this event
 * @property {string} item_id
 * @property {string} item_name - article name
 * @property {string} item_url - The article url
 * @property {string} lng
 * @property {string} objectId
 * @property {Url} referral_url - The url the user came from
 * @return {LogObject<clickOnAPictureWithinTheArticleParams>} LogObject<clickOnAPictureWithinTheArticleParams>
 */
export function clickOnAPictureWithinTheArticle(params) {
    return { evid: 627, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheFaqTutorialTab' event (evid: 538)
 *
 * @param {clickTheFaqTutorialTabParams} params - The parameters for this event
 * @property {string} item_name
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @property {string} source_url
 * @return {LogObject<clickTheFaqTutorialTabParams>} LogObject<clickTheFaqTutorialTabParams>
 */
export function clickTheFaqTutorialTab(params) {
    return { evid: 538, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'contactUsClickStillNeedHelp' event (evid: 529)
 *
 * @param {contactUsClickStillNeedHelpParams} params - The parameters for this event
 * @property {string} answer
 * @property {number} index
 * @property {string} lang
 * @property {string} question
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<contactUsClickStillNeedHelpParams>} LogObject<contactUsClickStillNeedHelpParams>
 */
export function contactUsClickStillNeedHelp(params) {
    return { evid: 529, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'questionTitleFieldSearch' event (evid: 509)
 *
 * @param {questionTitleFieldSearchParams} params - The parameters for this event
 * @property {number} count
 * @property {string} first_answer
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @property {string} title
 * @return {LogObject<questionTitleFieldSearchParams>} LogObject<questionTitleFieldSearchParams>
 */
export function questionTitleFieldSearch(params) {
    return { evid: 509, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'contactUsSelectCategory' event (evid: 525)
 *
 * @param {contactUsSelectCategoryParams} params - The parameters for this event
 * @property {string} category
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<contactUsSelectCategoryParams>} LogObject<contactUsSelectCategoryParams>
 */
export function contactUsSelectCategory(params) {
    return { evid: 525, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'ticketFormIsToggledInFaqPage' event (evid: 524)
 *
 * @param {ticketFormIsToggledInFaqPageParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @property {string} source_url
 * @return {LogObject<ticketFormIsToggledInFaqPageParams>} LogObject<ticketFormIsToggledInFaqPageParams>
 */
export function ticketFormIsToggledInFaqPage(params) {
    return { evid: 524, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'loginFailed' event (evid: 556)
 *
 * Event description: Login attempt to Answers failed
 *
 * @param {loginFailedParams} params - The parameters for this event
 * @property {string} lang - answers languages
 * @property {string} referral_name
 * @return {LogObject<loginFailedParams>} LogObject<loginFailedParams>
 */
export function loginFailed(params) {
    return { evid: 556, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnCloseSpecialCriticalBugNotice' event (evid: 8)
 *
 * @param {clickOnCloseSpecialCriticalBugNoticeParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickOnCloseSpecialCriticalBugNoticeParams>} LogObject<clickOnCloseSpecialCriticalBugNoticeParams>
 */
export function clickOnCloseSpecialCriticalBugNotice(params) {
    return { evid: 8, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnSearchInTheBottom' event (evid: 23)
 *
 * @param {clickOnSearchInTheBottomParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickOnSearchInTheBottomParams>} LogObject<clickOnSearchInTheBottomParams>
 */
export function clickOnSearchInTheBottom(params) {
    return { evid: 23, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'needMoreHelpButtonClickHere' event (evid: 2)
 *
 * @param {needMoreHelpButtonClickHereParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<needMoreHelpButtonClickHereParams>} LogObject<needMoreHelpButtonClickHereParams>
 */
export function needMoreHelpButtonClickHere(params) {
    return { evid: 2, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'forumSearchClickTheSeeAllResultsLink' event (evid: 548)
 *
 * Event description: click the 'see all results' link in the forum search
 *
 * @param {forumSearchClickTheSeeAllResultsLinkParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} question - question submitted by the user
 * @property {string} referral_name
 * @property {string} source_name - source page name
 * @property {string} source_url - source page url
 * @return {LogObject<forumSearchClickTheSeeAllResultsLinkParams>} LogObject<forumSearchClickTheSeeAllResultsLinkParams>
 */
export function forumSearchClickTheSeeAllResultsLink(params) {
    return { evid: 548, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnSubCategoryMainPage' event (evid: 30)
 *
 * @param {clickingOnSubCategoryMainPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnSubCategoryMainPageParams>} LogObject<clickingOnSubCategoryMainPageParams>
 */
export function clickingOnSubCategoryMainPage(params) {
    return { evid: 30, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'quickAssistClickOnContactUs' event (evid: 561)
 *
 * Event description: Clicking the "Contact Us" button
 *
 * @param {quickAssistClickOnContactUsParams} params - The parameters for this event
 * @property {string} block_id - the id of the block from which the user clicked Contact Us
 * @property {string} block_name - the name of the block from which the user clicked Contact Us
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} channel - channel the users came from
 * @property {boolean} contact_toggle - 1- contact option available from every block . 0- contact option available only after clicking 'wasn't helpful' and from 'get help with a different problem'
 * @property {string} content_id - the id of the selected content
 * @property {string} content_name - the name of the selected content
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers languages
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<quickAssistClickOnContactUsParams>} LogObject<quickAssistClickOnContactUsParams>
 */
export function quickAssistClickOnContactUs(params) {
    return { evid: 561, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'walkMeClickOnSubmitTicket' event (evid: 589)
 *
 * Event description: Clicking the "Submit Ticket" button in the WalkMe pop up.
 *
 * @param {walkMeClickOnSubmitTicketParams} params - The parameters for this event
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} referral_name - referral to the WalkMe tour
 * @property {Url} referral_url - referral to the WalkMe tour
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @return {LogObject<walkMeClickOnSubmitTicketParams>} LogObject<walkMeClickOnSubmitTicketParams>
 */
export function walkMeClickOnSubmitTicket(params) {
    return { evid: 589, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'contactUsClickMoreHelpOptions' event (evid: 530)
 *
 * @param {contactUsClickMoreHelpOptionsParams} params - The parameters for this event
 * @property {string} item_name
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<contactUsClickMoreHelpOptionsParams>} LogObject<contactUsClickMoreHelpOptionsParams>
 */
export function contactUsClickMoreHelpOptions(params) {
    return { evid: 530, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'chatbotArticleInteraction' event (evid: 626)
 *
 * Event description: A user interacts with an article suggested by the chatbot. For example, clicks "view full article" or scrolls down the article to read it
 *
 * @param {chatbotArticleInteractionParams} params - The parameters for this event
 * @property {string} chatbot_view - chatbot_view
 * @property {string} conversation_id
 * @property {string} item_id - ID of the article presented to the user
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name
 * @property {string} node_id - ID of the chatbot node
 * @property {string} parent_url - URL of the user when the action is taken
 * @property {string} previous_node_id
 * @property {string} referral_info - referral_info
 * @property {string} solution_title
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @return {LogObject<chatbotArticleInteractionParams>} LogObject<chatbotArticleInteractionParams>
 */
export function chatbotArticleInteraction(params) {
    return { evid: 626, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnChangeProductButton' event (evid: 24)
 *
 * @param {clickOnChangeProductButtonParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} item
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickOnChangeProductButtonParams>} LogObject<clickOnChangeProductButtonParams>
 */
export function clickOnChangeProductButton(params) {
    return { evid: 24, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheTopQuestionsOrAllTopQuestionsButton' event (evid: 500)
 *
 * @param {clickTheTopQuestionsOrAllTopQuestionsButtonParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<clickTheTopQuestionsOrAllTopQuestionsButtonParams>} LogObject<clickTheTopQuestionsOrAllTopQuestionsButtonParams>
 */
export function clickTheTopQuestionsOrAllTopQuestionsButton(params) {
    return { evid: 500, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnNewPostButtonFromAnswersOpenForm' event (evid: 32)
 *
 * @param {clickingOnNewPostButtonFromAnswersOpenFormParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<clickingOnNewPostButtonFromAnswersOpenFormParams>} LogObject<clickingOnNewPostButtonFromAnswersOpenFormParams>
 */
export function clickingOnNewPostButtonFromAnswersOpenForm(params) {
    return { evid: 32, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactOpenWixContactSuccess' event (evid: 570)
 *
 * Event description: User opens "Wix Contact" from desktop. The Contact form finished loading.
 *
 * @param {wixContactOpenWixContactSuccessParams} params - The parameters for this event
 * @property {string} ab_test_version - The A/B test version assigned to the user
 * @property {string} announcement_text - announcement shown to user
 * @property {string} context - base on which platform the event is trigger { Contact form, Direct}
 * @property {string} lang - Answers language
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} session_id - session_id
 * @property {number} ts - time since load started, in ms
 * @return {LogObject<wixContactOpenWixContactSuccessParams>} LogObject<wixContactOpenWixContactSuccessParams>
 */
export function wixContactOpenWixContactSuccess(params) {
    return { evid: 570, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnChangeProductLinkInTheVideo' event (evid: 14)
 *
 * @param {clickingOnChangeProductLinkInTheVideoParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} video
 * @return {LogObject<clickingOnChangeProductLinkInTheVideoParams>} LogObject<clickingOnChangeProductLinkInTheVideoParams>
 */
export function clickingOnChangeProductLinkInTheVideo(params) {
    return { evid: 14, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'loginClickingEmailUsSrc4Evid70' event (evid: 70)
 *
 * @param {loginClickingEmailUsSrc4Evid70Params} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<loginClickingEmailUsSrc4Evid70Params>} LogObject<loginClickingEmailUsSrc4Evid70Params>
 */
export function loginClickingEmailUsSrc4Evid70(params) {
    return { evid: 70, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactARecaptchaChallengeWasShowedToTheUser' event (evid: 600)
 *
 * Event description: the event is trigger when reCAPTCHA view is showed to the user
 * after he clicks on 'request a callback' button.
 *
 * @param {wixContactARecaptchaChallengeWasShowedToTheUserParams} params - The parameters for this event
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} solution_title - the title of the presented solution
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @return {LogObject<wixContactARecaptchaChallengeWasShowedToTheUserParams>} LogObject<wixContactARecaptchaChallengeWasShowedToTheUserParams>
 */
export function wixContactARecaptchaChallengeWasShowedToTheUser(params) {
    return { evid: 600, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'editorHelpOpened' event (evid: 49)
 *
 * @param {editorHelpOpenedParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url - the category/null-values=undefined subcategory string that the editor opened with
 * @return {LogObject<editorHelpOpenedParams>} LogObject<editorHelpOpenedParams>
 */
export function editorHelpOpened(params) {
    return { evid: 49, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'supportLandingPage' event (evid: 15)
 *
 * @param {supportLandingPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {number} product_id
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<supportLandingPageParams>} LogObject<supportLandingPageParams>
 */
export function supportLandingPage(params) {
    return { evid: 15, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickSignInButton' event (evid: 534)
 *
 * @param {clickSignInButtonParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<clickSignInButtonParams>} LogObject<clickSignInButtonParams>
 */
export function clickSignInButton(params) {
    return { evid: 534, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'scheduledCallHasBeenOpened' event (evid: 512)
 *
 * @param {scheduledCallHasBeenOpenedParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<scheduledCallHasBeenOpenedParams>} LogObject<scheduledCallHasBeenOpenedParams>
 */
export function scheduledCallHasBeenOpened(params) {
    return { evid: 512, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'whatIsMyName' event (evid: 535)
 *
 * @param {whatIsMyNameParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<whatIsMyNameParams>} LogObject<whatIsMyNameParams>
 */
export function whatIsMyName(params) {
    return { evid: 535, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactAnnouncementToggledOn' event (evid: 585)
 *
 * Event description: Announcement on the current issue has been toggled on
 *
 * @param {wixContactAnnouncementToggledOnParams} params - The parameters for this event
 * @property {string} announcement_text - the announcement that is shows to users
 * @property {string} lang - answers language
 * @return {LogObject<wixContactAnnouncementToggledOnParams>} LogObject<wixContactAnnouncementToggledOnParams>
 */
export function wixContactAnnouncementToggledOn(params) {
    return { evid: 585, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'replyATicketInFaqPage' event (evid: 505)
 *
 * @param {replyATicketInFaqPageParams} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<replyATicketInFaqPageParams>} LogObject<replyATicketInFaqPageParams>
 */
export function replyATicketInFaqPage(params) {
    return { evid: 505, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'loginSuccess' event (evid: 555)
 *
 * Event description: Login attempt to Answers succeeded
 *
 * @param {loginSuccessParams} params - The parameters for this event
 * @property {string} lang - answers languages
 * @property {string} referral_name
 * @return {LogObject<loginSuccessParams>} LogObject<loginSuccessParams>
 */
export function loginSuccess(params) {
    return { evid: 555, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerClickOnScheduleACallForLater' event (evid: 603)
 *
 * Event description: Clicking the “Schedule a call for later" button
 *
 * @param {callSchedulerClickOnScheduleACallForLaterParams} params - The parameters for this event
 * @property {string} context_area - context_area
 * @property {string} context_domain - context_domain
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {number} context_page_numlevels - context_page_numlevels
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_parenturl - context_parenturl
 * @property {string} context_platform - context_platform
 * @property {string} context_uuid - context_uuid
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} lang - User's Answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} referral_name - referral
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} type - demo or callback
 * @return {LogObject<callSchedulerClickOnScheduleACallForLaterParams>} LogObject<callSchedulerClickOnScheduleACallForLaterParams>
 */
export function callSchedulerClickOnScheduleACallForLater(params) {
    return { evid: 603, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnSubCategoryOnSecondPage' event (evid: 51)
 *
 * @param {clickingOnSubCategoryOnSecondPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnSubCategoryOnSecondPageParams>} LogObject<clickingOnSubCategoryOnSecondPageParams>
 */
export function clickingOnSubCategoryOnSecondPage(params) {
    return { evid: 51, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactClickOnMainOption' event (evid: 571)
 *
 * Event description: User clicks on a main option in "Step 1"
 *
 * @param {wixContactClickOnMainOptionParams} params - The parameters for this event
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @return {LogObject<wixContactClickOnMainOptionParams>} LogObject<wixContactClickOnMainOptionParams>
 */
export function wixContactClickOnMainOption(params) {
    return { evid: 571, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnTopicInCategoryPage' event (evid: 31)
 *
 * @param {clickingOnTopicInCategoryPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} topic_title
 * @return {LogObject<clickingOnTopicInCategoryPageParams>} LogObject<clickingOnTopicInCategoryPageParams>
 */
export function clickingOnTopicInCategoryPage(params) {
    return { evid: 31, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clientLoadAttempt' event (evid: 558)
 *
 * Event description: Sent when the page is served and loaded, but the actual app was not fully rendered yet.
 *
 * @param {clientLoadAttemptParams} params - The parameters for this event
 * @property {string} client_name - the client that is sending the event. e.g - app/public/widget_[id]
 * @property {string} lang
 * @property {string} referral_name
 * @return {LogObject<clientLoadAttemptParams>} LogObject<clientLoadAttemptParams>
 */
export function clientLoadAttempt(params) {
    return { evid: 558, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'oldContactFormSubmitForm' event (evid: 511)
 *
 * Event description: User submitted a ticket through the old contact form
 *
 * @param {oldContactFormSubmitFormParams} params - The parameters for this event
 * @property {string} category
 * @property {string} forum
 * @property {boolean} is_private
 * @property {boolean} is_walkme - Was the ticket opened from a WalkMe tour
 * @property {string} item_name
 * @property {string} item_url
 * @property {string} lang - answers language
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} solution_title - the title of the presented solution
 * @property {string} source
 * @property {string} source_name
 * @property {string} sub_category
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} ticket_id - the ticket id of the submitted query
 * @property {string} topic - the topic/assign group of the ticket
 * @property {string} type
 * @return {LogObject<oldContactFormSubmitFormParams>} LogObject<oldContactFormSubmitFormParams>
 */
export function oldContactFormSubmitForm(params) {
    return { evid: 511, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'chooseCategory' event (evid: 3)
 *
 * @param {chooseCategoryParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<chooseCategoryParams>} LogObject<chooseCategoryParams>
 */
export function chooseCategory(params) {
    return { evid: 3, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationAnsBiResendMyCode' event (evid: 618)
 *
 * Event description: The user asks for another SMS messages to be sent
 *
 * @param {smsVerificationAnsBiResendMyCodeParams} params - The parameters for this event
 * @return {LogObject<smsVerificationAnsBiResendMyCodeParams>} LogObject<smsVerificationAnsBiResendMyCodeParams>
 */
export function smsVerificationAnsBiResendMyCode(params) {
    return { evid: 618, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'whatIsMyNameSrc4Evid532' event (evid: 532)
 *
 * @param {whatIsMyNameSrc4Evid532Params} params - The parameters for this event
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<whatIsMyNameSrc4Evid532Params>} LogObject<whatIsMyNameSrc4Evid532Params>
 */
export function whatIsMyNameSrc4Evid532(params) {
    return { evid: 532, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixWidgetWidgetLauncherLoadedClient' event (evid: 661)
 *
 * Event description: The event is trigger when a launcher is loaded and show to the user
 *
 * @param {wixWidgetWidgetLauncherLoadedClientParams} params - The parameters for this event
 * @property {string} parent_name - where the widget is opened from (source page name)
 * @property {string} parent_url - where the widget is opened from (source page url)
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} source_name - source name
 * @return {LogObject<wixWidgetWidgetLauncherLoadedClientParams>} LogObject<wixWidgetWidgetLauncherLoadedClientParams>
 */
export function wixWidgetWidgetLauncherLoadedClient(params) {
    return { evid: 661, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationAnsBiTooManyMessages' event (evid: 617)
 *
 * Event description: The user has passed the limit for number of SMS messages sent
 *
 * @param {smsVerificationAnsBiTooManyMessagesParams} params - The parameters for this event
 * @return {LogObject<smsVerificationAnsBiTooManyMessagesParams>} LogObject<smsVerificationAnsBiTooManyMessagesParams>
 */
export function smsVerificationAnsBiTooManyMessages(params) {
    return { evid: 617, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixWidgetCloseAWidgetClient' event (evid: 663)
 *
 * Event description: The event is trigger when a  user closes the widget
 *
 * @param {wixWidgetCloseAWidgetClientParams} params - The parameters for this event
 * @property {string} close_method - close method {click,api}
 * @property {string} current_platform - current_platform - where that chat is opened from currently { Editor, Biz manager, Domain page .... }
 * @property {string} lang - Answer's lang
 * @property {string} module_name - last used module (home, chat, contact form, etc)
 * @property {string} open_method - open method (api,click)
 * @property {string} parent_name
 * @property {string} parent_url
 * @property {string} referral_name
 * @property {Url} referral_url - where the widget is opened from
 * @property {string} source_name - source name
 * @return {LogObject<wixWidgetCloseAWidgetClientParams>} LogObject<wixWidgetCloseAWidgetClientParams>
 */
export function wixWidgetCloseAWidgetClient(params) {
    return { evid: 663, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnTopicInCategoryPageSrc4Evid62' event (evid: 62)
 *
 * @param {clickingOnTopicInCategoryPageSrc4Evid62Params} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} title
 * @property {string} url
 * @return {LogObject<clickingOnTopicInCategoryPageSrc4Evid62Params>} LogObject<clickingOnTopicInCategoryPageSrc4Evid62Params>
 */
export function clickingOnTopicInCategoryPageSrc4Evid62(params) {
    return { evid: 62, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickViewYourPhoneTicketButton' event (evid: 541)
 *
 * Event description: click 'view your phone ticket' button in the screen following the phone number verification
 *
 * @param {clickViewYourPhoneTicketButtonParams} params - The parameters for this event
 * @property {string} call_type - phone call options: scheduled a call \ call now
 * @property {string} category - the subcategory the user selected
 * @property {number} eta - the estimated wait time presented to the user
 * @property {string} issue_id - unique identifier of phone ticket
 * @property {GUID} item_id - ticket id
 * @property {string} item_name - the title that user provided
 * @property {string} lang
 * @property {string} phone - phone number submitted by the user
 * @property {string} referral_name
 * @property {string} type - question\bug\wishlist
 * @return {LogObject<clickViewYourPhoneTicketButtonParams>} LogObject<clickViewYourPhoneTicketButtonParams>
 */
export function clickViewYourPhoneTicketButton(params) {
    return { evid: 541, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'talkToWixSupportOnThePhoneContinue' event (evid: 539)
 *
 * Event description: clicking the Continue button at the bottom of the 'talk to wix support on the phone' page
 *
 * @param {talkToWixSupportOnThePhoneContinueParams} params - The parameters for this event
 * @property {string} call_type - phone call options: scheduled a call \ call now
 * @property {string} category - the subcategory the user selected
 * @property {number} eta - the estimated wait time presented to the user
 * @property {string} item_name - the title that user provided
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @property {string} type - question\bug\wishlist
 * @return {LogObject<talkToWixSupportOnThePhoneContinueParams>} LogObject<talkToWixSupportOnThePhoneContinueParams>
 */
export function talkToWixSupportOnThePhoneContinue(params) {
    return { evid: 539, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'scheduleACallChangeCountry' event (evid: 543)
 *
 * Event description: change country in the 'schedule a call with Wix Support' page
 *
 * @param {scheduleACallChangeCountryParams} params - The parameters for this event
 * @property {string} call_type - phone call options: scheduled a call \ call now
 * @property {string} category - the subcategory the user selected
 * @property {number} eta - the estimated wait time presented to the user
 * @property {string} issue_id - unique identifier of phone ticket
 * @property {GUID} item_id - ticket id
 * @property {string} item_name - the title that user provided
 * @property {string} lang
 * @property {string} org_country - the country code presented to the user
 * @property {string} phone - phone number submitted by the user
 * @property {string} referral_name
 * @property {string} target_country - the country the user selected from the drop down menu
 * @property {string} type - question\bug\wishlist
 * @return {LogObject<scheduleACallChangeCountryParams>} LogObject<scheduleACallChangeCountryParams>
 */
export function scheduleACallChangeCountry(params) {
    return { evid: 543, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'postNewTopicClickingOnButtonOpenForm' event (evid: 67)
 *
 * @param {postNewTopicClickingOnButtonOpenFormParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {GUID} forumid
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<postNewTopicClickingOnButtonOpenFormParams>} LogObject<postNewTopicClickingOnButtonOpenFormParams>
 */
export function postNewTopicClickingOnButtonOpenForm(params) {
    return { evid: 67, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'linkTicketToKbItemAdminAction' event (evid: 700)
 *
 * Event description: admin linking a ticket to a kb item when providing assistance to a user
 *
 * @param {linkTicketToKbItemAdminActionParams} params - The parameters for this event
 * @property {string} item_id - linked kb item
 * @property {string} lang - answers languages
 * @property {string} ticket_id - the ticket id the agent linked to a kb item
 * @property {GUID} uuid
 * @return {LogObject<linkTicketToKbItemAdminActionParams>} LogObject<linkTicketToKbItemAdminActionParams>
 */
export function linkTicketToKbItemAdminAction(params) {
    return { evid: 700, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnCategoryOnMainPage' event (evid: 50)
 *
 * @param {clickingOnCategoryOnMainPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickingOnCategoryOnMainPageParams>} LogObject<clickingOnCategoryOnMainPageParams>
 */
export function clickingOnCategoryOnMainPage(params) {
    return { evid: 50, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheContactUsLink' event (evid: 515)
 *
 * @param {clickTheContactUsLinkParams} params - The parameters for this event
 * @property {string} item_name
 * @property {string} item_url
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @return {LogObject<clickTheContactUsLinkParams>} LogObject<clickTheContactUsLinkParams>
 */
export function clickTheContactUsLink(params) {
    return { evid: 515, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'forumSearchClickOnAnswer' event (evid: 547)
 *
 * Event description: click one of the answers in the forum search
 *
 * @param {forumSearchClickOnAnswerParams} params - The parameters for this event
 * @property {string} answer - answer the user clicked on
 * @property {number} order - index of the selected answer
 * @property {string} lang
 * @property {string} question - question submitted by the user
 * @property {string} referral_name
 * @property {string} source_name - source page name
 * @property {string} source_url - source page url
 * @return {LogObject<forumSearchClickOnAnswerParams>} LogObject<forumSearchClickOnAnswerParams>
 */
export function forumSearchClickOnAnswer(params) {
    return { evid: 547, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheSuggestedAnswerButton' event (evid: 510)
 *
 * @param {clickTheSuggestedAnswerButtonParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} first_answer
 * @property {string} lang
 * @property {string} referral_name
 * @property {string} source_name
 * @property {string} title
 * @return {LogObject<clickTheSuggestedAnswerButtonParams>} LogObject<clickTheSuggestedAnswerButtonParams>
 */
export function clickTheSuggestedAnswerButton(params) {
    return { evid: 510, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'signInDialogOpened' event (evid: 34)
 *
 * @param {signInDialogOpenedParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<signInDialogOpenedParams>} LogObject<signInDialogOpenedParams>
 */
export function signInDialogOpened(params) {
    return { evid: 34, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'verifyNumberButton' event (evid: 540)
 *
 * Event description: click the verify number button
 *
 * @param {verifyNumberButtonParams} params - The parameters for this event
 * @property {string} call_type - phone call options: scheduled a call \ call now
 * @property {string} category - the subcategory the user selected
 * @property {number} eta - estimated wait time
 * @property {string} item_name - the title that user provided
 * @property {string} lang
 * @property {string} phone - phone number submitted by the user
 * @property {string} referral_name
 * @property {string} source_name - the page they clicked this button on
 * @property {Url} source_url - the page they clicked this button on
 * @property {string} type - question\bug\wishlist
 * @return {LogObject<verifyNumberButtonParams>} LogObject<verifyNumberButtonParams>
 */
export function verifyNumberButton(params) {
    return { evid: 540, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'loginAttempt' event (evid: 554)
 *
 * Event description: User attempts to login to Answer
 *
 * @param {loginAttemptParams} params - The parameters for this event
 * @property {string} lang - answers languages
 * @property {string} referral_name
 * @return {LogObject<loginAttemptParams>} LogObject<loginAttemptParams>
 */
export function loginAttempt(params) {
    return { evid: 554, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'smsVerificationAnsBiCodeSubmissionFormOpened' event (evid: 614)
 *
 * Event description: The verification message is received by the phone number entered by the user.
 *
 * @param {smsVerificationAnsBiCodeSubmissionFormOpenedParams} params - The parameters for this event
 * @return {LogObject<smsVerificationAnsBiCodeSubmissionFormOpenedParams>} LogObject<smsVerificationAnsBiCodeSubmissionFormOpenedParams>
 */
export function smsVerificationAnsBiCodeSubmissionFormOpened(params) {
    return { evid: 614, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnBackToTopButton' event (evid: 21)
 *
 * @param {clickOnBackToTopButtonParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @return {LogObject<clickOnBackToTopButtonParams>} LogObject<clickOnBackToTopButtonParams>
 */
export function clickOnBackToTopButton(params) {
    return { evid: 21, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnFaqInThirdPage' event (evid: 56)
 *
 * @param {clickingOnFaqInThirdPageParams} params - The parameters for this event
 * @property {string} answer
 * @property {string} category
 * @property {string} forum
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} question
 * @property {string} sub_category
 * @property {string} url
 * @return {LogObject<clickingOnFaqInThirdPageParams>} LogObject<clickingOnFaqInThirdPageParams>
 */
export function clickingOnFaqInThirdPage(params) {
    return { evid: 56, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'deleteMe' event (evid: 9)
 *
 * Event description: pp
 *
 * @param {deleteMeParams} params - The parameters for this event
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<deleteMeParams>} LogObject<deleteMeParams>
 */
export function deleteMe(params) {
    return { evid: 9, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickingOnSubCategoryOnHomePage' event (evid: 11)
 *
 * Event description: clicking on sub- category on home page.
 *
 * @param {clickingOnSubCategoryOnHomePageParams} params - The parameters for this event
 * @property {string} forum - Identifier of the wix product (flash/html)
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickingOnSubCategoryOnHomePageParams>} LogObject<clickingOnSubCategoryOnHomePageParams>
 */
export function clickingOnSubCategoryOnHomePage(params) {
    return { evid: 11, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'changeLanguage' event (evid: 25)
 *
 * Event description: change language.
 *
 * @param {changeLanguageParams} params - The parameters for this event
 * @property {string} forum - Identifier of the wix product (flash/html)
 * @property {string} question - question
 * @property {string} sub_category - sub_category
 * @property {string} url - url
 * @property {string} to_language - to_language
 * @property {string} target_url - target_url
 * @property {GUID} __cookies_prefix__s_session_id - session
 * @property {string} __cookies_prefix__WixYoutube_ab - ablabel
 * @property {string} answer - answer
 * @property {string} category - category
 * @property {string} from_language - from_language
 * @property {string} product - Identifier of the wix product (flash/html)
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<changeLanguageParams>} LogObject<changeLanguageParams>
 */
export function changeLanguage(params) {
    return { evid: 25, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheWasItHelpfulButtons' event (evid: 501)
 *
 * Event description: fired when a user votes helpful/unhelpful
 *
 * @param {clickTheWasItHelpfulButtonsParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {GUID} item_id - item_id
 * @property {boolean} thumbs_up - Indicate if the user vote helpful or unhelpful
 * @property {string} sub_category - sub_category
 * @property {string} block_name - block_name
 * @property {string} referral_name - referral_name
 * @property {Url} referral_url - referral_url
 * @property {string} feedback_details - feedback_details
 * @property {string} panel_name - the editor component the widget was opened from{header settings, add a button...}
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} item_name - item_name
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} origin - the editor component the widget was opened from {gfpp, panel, tool bar, top bar, add menu}
 * @property {string} editor_working_mode - editor mode {desktop, mobile}
 * @property {string} category - category
 * @property {string} block_id - block_id
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} item_type - item_type
 * @property {string} kb_version - kb_version
 * @return {LogObject<clickTheWasItHelpfulButtonsParams>} LogObject<clickTheWasItHelpfulButtonsParams>
 */
export function clickTheWasItHelpfulButtons(params) {
    return { evid: 501, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'voteUnVoteForWishList' event (evid: 502)
 *
 * Event description: fired when a user votes for a feature request
 *
 * @param {voteUnVoteForWishListParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {GUID} item_id - include the article_id
 * @property {boolean} thumbs_up - Indicate if the user vote or unvote
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {string} tab - tab
 * @property {string} filter_by - filter_by
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} item_name - item_name
 * @property {string} vote_type - vote_type
 * @property {string} source_name - the kb page the vote occurred on. Can be article or roadmap.
 * @property {string} sort_by - sort_by
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} source_component_name - source_component_name
 * @property {string} item_type - item_type
 * @property {string} kb_version - kb_version
 * @return {LogObject<voteUnVoteForWishListParams>} LogObject<voteUnVoteForWishListParams>
 */
export function voteUnVoteForWishList(params) {
    return { evid: 502, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheIHaveThisProblemBugButton' event (evid: 503)
 *
 * Event description: fired when a user votes for a known issue
 *
 * @param {clickTheIHaveThisProblemBugButtonParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} item_id - item_id
 * @property {boolean} thumbs_up - Indicate if the user vote or unvote
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} item_name - item_name
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} item_type - item_type
 * @property {string} kb_version - kb_version
 * @return {LogObject<clickTheIHaveThisProblemBugButtonParams>} LogObject<clickTheIHaveThisProblemBugButtonParams>
 */
export function clickTheIHaveThisProblemBugButton(params) {
    return { evid: 503, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheFollowUnFollowButton' event (evid: 504)
 *
 * Event description: fired when users (wix users) click the top bar chackbox to follow/unfollow an article in the help center
 *
 * @param {clickTheFollowUnFollowButtonParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {GUID} item_id - the article's id
 * @property {boolean} thumbs_up - Indicate if the user follow or unfollow
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {string} item_name - item_name
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} category - category
 * @property {string} kb_lang - kb_lang
 * @property {string} lang - lng
 * @property {string} item_type - item_type
 * @property {string} kb_version - kb_version
 * @return {LogObject<clickTheFollowUnFollowButtonParams>} LogObject<clickTheFollowUnFollowButtonParams>
 */
export function clickTheFollowUnFollowButton(params) {
    return { evid: 504, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheForumLink' event (evid: 514)
 *
 * Event description: click the forum link.
 *
 * @param {clickTheForumLinkParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} referral_name - referral_name
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickTheForumLinkParams>} LogObject<clickTheForumLinkParams>
 */
export function clickTheForumLink(params) {
    return { evid: 514, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickAContent' event (evid: 517)
 *
 * Event description: click a content.
 *
 * @param {clickAContentParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} source_url - source_url
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {boolean} from_search - indicator if this is a click on any of the search results
 * @property {string} item_name - item_name
 * @property {string} source_name - source_name
 * @property {string} order - order
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - lng
 * @property {string} type - type
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickAContentParams>} LogObject<clickAContentParams>
 */
export function clickAContent(params) {
    return { evid: 517, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'chooseACategoryAndSubcategory' event (evid: 519)
 *
 * Event description: choose a category and subcategory.
 *
 * @param {chooseACategoryAndSubcategoryParams} params - The parameters for this event
 * @property {string} source_url - source_url
 * @property {string} sub_category - sub_category
 * @property {string} referral_name - referral_name
 * @property {string} source_name - source_name
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<chooseACategoryAndSubcategoryParams>} LogObject<chooseACategoryAndSubcategoryParams>
 */
export function chooseACategoryAndSubcategory(params) {
    return { evid: 519, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'askingAQuestion' event (evid: 520)
 *
 * Event description: Fired when the user starts searching in the search bar
 *
 * @param {askingAQuestionParams} params - The parameters for this event
 * @property {string} question - The search term the user searched for
 * @property {string} source_url - source_url
 * @property {string} item_id - item_id
 * @property {string} referral_name - referral_name
 * @property {string} search_method - search_method
 * @property {string} search_session_Id - search_session_id
 * @property {string} presented_content - presented_content
 * @property {string} panel_name - the editor component the widget was opened from {header settings, add a button...}
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} first_answer - first_answer
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} search_version - name of search model used
 * @property {string} origin - the editor component the widget was opened from {gfpp, panel, tool bar, top bar, add menu}
 * @property {string} request_id - request_id
 * @property {string} editor_working_mode - editor mode {desktop, mobile}
 * @property {string} kb_lang - kb page language
 * @property {string} related_item - related_item
 * @property {boolean} has_related - has_related
 * @property {string} lang - wix language
 * @property {DateTime} action_date - action_date
 * @property {string} item_type - item_type
 * @property {string} kb_version - kb_version
 * @property {string} conduction_value - Perti conduction_value
 * @return {LogObject<askingAQuestionParams>} LogObject<askingAQuestionParams>
 */
export function askingAQuestion(params) {
    return { evid: 520, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnAnswer' event (evid: 521)
 *
 * Event description: Fired when the user selects one of the search results
 *
 * @param {clickOnAnswerParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} question - The search term the user searched for
 * @property {string} search_result_selection - search_result_selection
 * @property {string} source_url - source_url
 * @property {string} item_id - item_id
 * @property {boolean} is_related - is_related
 * @property {string} referral_name - referral_name
 * @property {string} search_method - search_method
 * @property {string} search_session_Id - search_session_id
 * @property {string} panel_name - the editor component the widget was opened from {header settings, add a button...}
 * @property {string} clicked_item_order - clicked_item_order
 * @property {string} clicked_item_type - clicked_item_type
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} clicked_item_id - clicked_item_id
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} search_version - name of search model used
 * @property {string} order - order
 * @property {string} origin - the editor component the widget was opened from {gfpp, panel, tool bar, top bar, add menu}
 * @property {string} editor_working_mode - editor mode {desktop, mobile}
 * @property {string} answer - answer
 * @property {string} kb_lang - kb page language
 * @property {string} related_item - related_item
 * @property {boolean} has_related - has_related
 * @property {string} lang - wix language
 * @property {DateTime} action_date - action_date
 * @property {string} item_type - item_type
 * @property {string} kb_version - kb_version
 * @property {number} page_number - The results page number on which the results the user chose was on
 * @property {string} clicked_url - clicked_url
 * @return {LogObject<clickOnAnswerParams>} LogObject<clickOnAnswerParams>
 */
export function clickOnAnswer(params) {
    return { evid: 521, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickTheSeeAllResultsLink' event (evid: 522)
 *
 * Event description: Fired when the user clicks the option to see all search results
 *
 * @param {clickTheSeeAllResultsLinkParams} params - The parameters for this event
 * @property {string} question - text entered by the user in the search bar
 * @property {string} source_url - source_url
 * @property {string} item_id - item_id
 * @property {string} referral_name - referral_name
 * @property {string} search_method - search_method
 * @property {string} search_session_Id - search_session_id
 * @property {string} source_name - indicates what type of article the user is at:
 * home, article, category, search_results
 * @property {string} search_version - name of search model used
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} item_type - item_type
 * @property {string} kb_version - kb_version
 * @property {string} source_type_trigger - the source name of the source in which the user clicks the 'show x more'. If the user clicks the general 'show all results' value will get 'general'.
 * @return {LogObject<clickTheSeeAllResultsLinkParams>} LogObject<clickTheSeeAllResultsLinkParams>
 */
export function clickTheSeeAllResultsLink(params) {
    return { evid: 522, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'pageView' event (evid: 531)
 *
 * Event description: Fired when the user enters a page in the KB
 *
 * @param {pageViewParams} params - The parameters for this event
 * @property {string} item_url - item_url
 * @property {string} question - question
 * @property {string} item_id - item_id
 * @property {string} item_version - item_version
 * @property {string} referral_name - referral_name
 * @property {string} faq_type - faq_type
 * @property {Url} referral_url - referral_url
 * @property {boolean} max_scroll_at_first_position - max_scroll_at_first_position
 * @property {string} tab - tab
 * @property {string} submit_mode - submit_mode
 * @property {string} filter_by - filter_by
 * @property {GUID} search_session_Id - search_session_id
 * @property {string} presented_content - presented_content
 * @property {string} panel_name - the editor component the widget was opened from {header settings, add a button...}
 * @property {string} personalized_content - Include all the personalized content on that page
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} item_name - item_name
 * @property {string} petri_conduciton_value - petri_conduciton_value
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} origin - the editor component the widget was opened from {gfpp, panel, tool bar, top bar, add menu}
 * @property {string} sort_by - sort_by
 * @property {string} editor_working_mode - editor mode {desktop, mobile}
 * @property {string} previous_page - previous_page
 * @property {string} category - category
 * @property {string} kb_lang - kb page language
 * @property {string} lang - wix language
 * @property {string} item_type - item_type
 * @property {string} ab_test_version - ab_test_version
 * @property {string} kb_version - kb_version
 * @property {number} screen_width - The user's screen width
 * @property {number} screen_height - The user's screen height
 * @return {LogObject<pageViewParams>} LogObject<pageViewParams>
 */
export function pageView(params) {
    return { evid: 531, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickedOutsideBox' event (evid: 536)
 *
 * Event description: clicked outside box.
 *
 * @param {clickedOutsideBoxParams} params - The parameters for this event
 * @property {string} question - question
 * @property {string} source_url - source_url
 * @property {string} referral_name - referral_name
 * @property {string} first_answer - first_answer
 * @property {string} source_name - source_name
 * @property {string} lang - lng
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickedOutsideBoxParams>} LogObject<clickedOutsideBoxParams>
 */
export function clickedOutsideBox(params) {
    return { evid: 536, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'gotNoAnswer' event (evid: 537)
 *
 * Event description: Fire when no results return after the user search in the help center
 *
 * @param {gotNoAnswerParams} params - The parameters for this event
 * @property {string} question - The search term the user searched for
 * @property {string} source_url - source_url
 * @property {string} referral_name - referral_name
 * @property {string} search_method - search method
 * @property {string} panel_name - the editor component the widget was opened from {header settings, add a button...}
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} dashboard_hosting - dashboard_hosting
 * @property {string} source_name - indicates what page the user is at: home, article, category, search_results
 * @property {string} search_version - name of search model used
 * @property {string} origin - the editor component the widget was opened from {gfpp, panel, tool bar, top bar, add menu}
 * @property {string} editor_working_mode - editor mode {desktop, mobile}
 * @property {string} kb_lang - kb page language
 * @property {string} lang - lng
 * @property {GUID} msid - msid
 * @return {LogObject<gotNoAnswerParams>} LogObject<gotNoAnswerParams>
 */
export function gotNoAnswer(params) {
    return { evid: 537, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clientLoadSuccess' event (evid: 559)
 *
 * Event description: Sent when the client app was fully rendered (all ajax requests completed, etc).
 *
 * @param {clientLoadSuccessParams} params - The parameters for this event
 * @property {string} referral_name - referral_name
 * @property {number} ts - time since load started, in ms
 * @property {string} client_name - the client that is sending the event. e.g - app/public/widget_[id]
 * @property {string} source_name - source_name
 * @property {string} lang - answers version of lang
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clientLoadSuccessParams>} LogObject<clientLoadSuccessParams>
 */
export function clientLoadSuccess(params) {
    return { evid: 559, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wasItHelpfulSubmitFeedbackForm' event (evid: 569)
 *
 * Event description: Click submit feedback form after marking an article as unhelpful (evid 501, thumbs_down false)
 *
 * @param {wasItHelpfulSubmitFeedbackFormParams} params - The parameters for this event
 * @property {string} item_url - article url
 * @property {GUID} item_id - article id
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} feedback - the feedback the user submitted
 * @property {string} item_name - article name
 * @property {string} source_name - widget name
 * @property {string} lang - answers language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wasItHelpfulSubmitFeedbackFormParams>} LogObject<wasItHelpfulSubmitFeedbackFormParams>
 */
export function wasItHelpfulSubmitFeedbackForm(params) {
    return { evid: 569, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactSolutionView' event (evid: 573)
 *
 * Event description: A solution is presented to the user in "step 3"
 *
 * @param {wixContactSolutionViewParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} item_id - ID of the article presented to the user
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} node_id - ID of the chatbot node
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactSolutionViewParams>} LogObject<wixContactSolutionViewParams>
 */
export function wixContactSolutionView(params) {
    return { evid: 573, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactClickOnTheActionButton' event (evid: 574)
 *
 * Event description: User click on the action button next to the solution content
 *
 * @param {wixContactClickOnTheActionButtonParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} chatbot_view - chatbot_view
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} sub_option_id - the id of the final sub option
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixContactClickOnTheActionButtonParams>} LogObject<wixContactClickOnTheActionButtonParams>
 */
export function wixContactClickOnTheActionButton(params) {
    return { evid: 574, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactClickOnALinkInsideASolution' event (evid: 575)
 *
 * Event description: User click on a link inside the solution content
 *
 * @param {wixContactClickOnALinkInsideASolutionParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} link_name - the clickable text
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {Url} link_url - the link's url
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactClickOnALinkInsideASolutionParams>} LogObject<wixContactClickOnALinkInsideASolutionParams>
 */
export function wixContactClickOnALinkInsideASolution(params) {
    return { evid: 575, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactSubmitTicketForm' event (evid: 577)
 *
 * Event description: Clicking the "Submit a ticket" button at the bottom of the ticket form
 *
 * @param {wixContactSubmitTicketFormParams} params - The parameters for this event
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form,Direct}
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} topic - the topic of the ticket (selected from the "Issue Subject" dropdown)
 * @property {string} lang - answers language
 * @property {string} platform - NULL
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactSubmitTicketFormParams>} LogObject<wixContactSubmitTicketFormParams>
 */
export function wixContactSubmitTicketForm(params) {
    return { evid: 577, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactClickOnRequestCallback' event (evid: 578)
 *
 * Event description: Clicking the "Request Callback" button
 *
 * @param {wixContactClickOnRequestCallbackParams} params - The parameters for this event
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactClickOnRequestCallbackParams>} LogObject<wixContactClickOnRequestCallbackParams>
 */
export function wixContactClickOnRequestCallback(params) {
    return { evid: 578, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactSubmitCallbackForm' event (evid: 579)
 *
 * Event description: Clicking the "Request Callback" button at the bottom of the callback form
 *
 * @param {wixContactSubmitCallbackFormParams} params - The parameters for this event
 * @property {string} chat_status - is the chat available for conversations, closed, etc.
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} node_id - node_id
 * @property {string} widget_view_mode - indicates if the user is using the widget while editing the Mobile or Desktop site
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} referral - referral
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactSubmitCallbackFormParams>} LogObject<wixContactSubmitCallbackFormParams>
 */
export function wixContactSubmitCallbackForm(params) {
    return { evid: 579, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactCallbackSuccess' event (evid: 580)
 *
 * Event description: User was able to schedule a callback
 *
 * @param {wixContactCallbackSuccessParams} params - The parameters for this event
 * @property {string} ticket_id - answers' ticket id of the created call
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - widget, full screen, iframe etc.
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} announcement_text - announcement that is shown to user
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - action_url
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {number} clid - wcc call guid
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {GUID} callid - answers call guid
 * @property {boolean} view_recaptcha - true if user saw the recaptcha view and false if not
 * @property {string} lang - lang
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactCallbackSuccessParams>} LogObject<wixContactCallbackSuccessParams>
 */
export function wixContactCallbackSuccess(params) {
    return { evid: 580, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactCallbackFailedClient' event (evid: 581)
 *
 * Event description: User was not able to schedule a callback
 *
 * @param {wixContactCallbackFailedClientParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - previous_node_id
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - chatbot_view
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form,Direct}
 * @property {string} node_id - node_id
 * @property {string} server_error - the actual reason why user failed to request callback
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - referral_info
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} reason - reason for callback fail (the number of the error) , for getting the actual reason use the server_error field
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {boolean} view_recaptcha - true if user saw the recaptcha view and false if not
 * @property {string} lang - answers language
 * @property {string} platform - Null
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactCallbackFailedClientParams>} LogObject<wixContactCallbackFailedClientParams>
 */
export function wixContactCallbackFailedClient(params) {
    return { evid: 581, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactTicketSubmissionSuccessClient' event (evid: 582)
 *
 * Event description: User was able to submit a ticket through "Wix Contact"
 *
 * @param {wixContactTicketSubmissionSuccessClientParams} params - The parameters for this event
 * @property {string} ticket_id - ticket_id
 * @property {string} main_option_id - main_option_id
 * @property {string} referral_name - referral_name
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral_url
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - widget, full screen, etc.
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { contact form, SMS page etc}
 * @property {string} sub_option_name - sub_option_name
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - call_center_status
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - sub_option_id
 * @property {string} announcement_text - announcement that is shown to user
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - solution_time
 * @property {string} main_option_name - main_option_name
 * @property {string} suggestion_id - suggestion_id
 * @property {string} ticket_url - ticket_url
 * @property {number} estimated_wait_time - estimated_wait_time
 * @property {string} topic - topic
 * @property {string} lang - lang
 * @property {string} solution_title - solution_title
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - ticketing_status
 * @property {string} chatbot_state - chatbot_state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactTicketSubmissionSuccessClientParams>} LogObject<wixContactTicketSubmissionSuccessClientParams>
 */
export function wixContactTicketSubmissionSuccessClient(params) {
    return { evid: 582, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactTicketSubmissionFailedClient' event (evid: 584)
 *
 * Event description: User was not able to submit a ticket through "Wix Contact"
 *
 * @param {wixContactTicketSubmissionFailedClientParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {string} provider - the back-end that serves the contact option - wcc\answers
 * @property {Url} referral_url - referral
 * @property {string} context_platform - Desktop/mobile/app/unknown
 * @property {string} chatbot_view - widget, full screen, iframe etc.
 * @property {string} context_area - context_area
 * @property {string} node_id - ID of the current stage type
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - Full url where the widget is
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} reason - reason for ticket tubmission fail
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} topic - the topic of the ticket (selected from the "Issue Subject" dropdown)
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} context_iframeurllist - All iframes url on page
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactTicketSubmissionFailedClientParams>} LogObject<wixContactTicketSubmissionFailedClientParams>
 */
export function wixContactTicketSubmissionFailedClient(params) {
    return { evid: 584, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'articleClickActionButton' event (evid: 588)
 *
 * Event description: click an action button inside an article
 *
 * @param {articleClickActionButtonParams} params - The parameters for this event
 * @property {GUID} item_id - the id of the article the button was click in
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {Url} action_url - the URL of the action button
 * @property {string} item_name - the name of the article the button was click in
 * @property {string} source_name - the page they clicked the button on
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} kb_lang - kb page language
 * @property {string} lang - Answers language
 * @property {string} conversation_id - conversation id from the chatbot (null if context != chatbot)
 * @property {string} action_text - the text that appear on the button
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<articleClickActionButtonParams>} LogObject<articleClickActionButtonParams>
 */
export function articleClickActionButton(params) {
    return { evid: 588, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactOpenWixContactAttempt' event (evid: 592)
 *
 * Event description: User opens "Wix Contact" from desktop. The Contact form has started to load.
 *
 * @param {wixContactOpenWixContactAttemptParams} params - The parameters for this event
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - referral
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} lang - Answers language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixContactOpenWixContactAttemptParams>} LogObject<wixContactOpenWixContactAttemptParams>
 */
export function wixContactOpenWixContactAttempt(params) {
    return { evid: 592, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'articleClickOnBanner' event (evid: 594)
 *
 * Event description: click on a banner inside an article
 *
 * @param {articleClickOnBannerParams} params - The parameters for this event
 * @property {string} banner_text - the text that appear on the banner
 * @property {GUID} item_id - the id of the article the banner was click in
 * @property {string} referral_name - referral
 * @property {Url} referral_url - referral
 * @property {string} selectedCompType - the editor component the widget was opened from
 * @property {string} item_name - the name of the article the banner was click in
 * @property {string} source_name - the page they clicked the button on
 * @property {Url} banner_url - the target URL of the banner
 * @property {string} lang - Answers language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<articleClickOnBannerParams>} LogObject<articleClickOnBannerParams>
 */
export function articleClickOnBanner(params) {
    return { evid: 594, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactClickOnChatLive' event (evid: 596)
 *
 * Event description: Clicking the "Chat LIve" button
 *
 * @param {wixContactClickOnChatLiveParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - referral
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - widget, full screen, iframe etc.
 * @property {string} context_areaa - context_areaa
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} node_id - ID of the chatbot node
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution contetnt
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation_id from the chatbot
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} live_chat_group - reason the user is seeing the live chat option
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactClickOnChatLiveParams>} LogObject<wixContactClickOnChatLiveParams>
 */
export function wixContactClickOnChatLive(params) {
    return { evid: 596, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixContactOpenChatSuccessClient' event (evid: 597)
 *
 * Event description: User was able to open a chat conversation
 *
 * @param {wixContactOpenChatSuccessClientParams} params - The parameters for this event
 * @property {string} ticket_id - answers' ticket id of the created chat
 * @property {GUID} chatid - answers chat guid
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} previous_node_id - node ID of the previous chatbot message
 * @property {string} session_id - Widget session ID
 * @property {Url} referral_url - referral
 * @property {string} context_platform - context_platform
 * @property {string} chatbot_view - widget, full screen, iframe etc.
 * @property {string} context_area - context_area
 * @property {string} context - base on which platform the event is trigger { Contact form, Other}
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} call_center_status - is the call center available for calls, closed, etc.
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} referral_info - the string from the queryparam, for example generalDashboard or restaurantsTOF
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} announcement_text - announcement that is shown to user
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {Url} action_url - the url of the suggested action button, next to the solution content
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {number} solution_time - in minutes, the estimated time presented to the user to solve the issue by themselves
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - suggestion_id
 * @property {number} estimated_wait_time - in minutes, the estimated callback wait time presented to the user
 * @property {string} lang - answers language
 * @property {string} solution_title - the title of the presented solution
 * @property {string} conversation_id - conversation_id from the chatbot
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} ticketing_status - is the option to submit a ticket is available
 * @property {string} chatbot_state - chatbot_state
 * @property {string} live_chat_group - reason the user is seeing the live chat option
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<wixContactOpenChatSuccessClientParams>} LogObject<wixContactOpenChatSuccessClientParams>
 */
export function wixContactOpenChatSuccessClient(params) {
    return { evid: 597, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerSubmitScheduledCallbackRequest' event (evid: 604)
 *
 * Event description: Clicking the "Schedule a Callback" button at the bottom of the Call Scheduler
 *
 * @param {callSchedulerSubmitScheduledCallbackRequestParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerSubmitScheduledCallbackRequestParams>} LogObject<callSchedulerSubmitScheduledCallbackRequestParams>
 */
export function callSchedulerSubmitScheduledCallbackRequest(params) {
    return { evid: 604, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerScheduledCallbackSuccess' event (evid: 605)
 *
 * Event description: User was able to schedule a callback
 *
 * @param {callSchedulerScheduledCallbackSuccessParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {GUID} queue_id - Id of the Answers queue the call will enter
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerScheduledCallbackSuccessParams>} LogObject<callSchedulerScheduledCallbackSuccessParams>
 */
export function callSchedulerScheduledCallbackSuccess(params) {
    return { evid: 605, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerClickRescheduleOrCancelCall' event (evid: 606)
 *
 * Event description: User clicks the "Reschedule or cancel call" button after scheduling a call
 *
 * @param {callSchedulerClickRescheduleOrCancelCallParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickRescheduleOrCancelCallParams>} LogObject<callSchedulerClickRescheduleOrCancelCallParams>
 */
export function callSchedulerClickRescheduleOrCancelCall(params) {
    return { evid: 606, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerClickCancel' event (evid: 607)
 *
 * Event description: User clicks the "Cancel" button on the My Scheduled Callbacks page.
 *
 * @param {callSchedulerClickCancelParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickCancelParams>} LogObject<callSchedulerClickCancelParams>
 */
export function callSchedulerClickCancel(params) {
    return { evid: 607, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerClickReschedule' event (evid: 608)
 *
 * Event description: User clicks the "Reschedule" button on the My Scheduled Callbacks page.
 *
 * @param {callSchedulerClickRescheduleParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerClickRescheduleParams>} LogObject<callSchedulerClickRescheduleParams>
 */
export function callSchedulerClickReschedule(params) {
    return { evid: 608, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerOpenMyScheduledCallsPage' event (evid: 609)
 *
 * Event description: User opens the My Scheduled Calls page
 *
 * @param {callSchedulerOpenMyScheduledCallsPageParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} button_name - The button the user clicked on to access this page. (Done/Reschedule or cancel call/X)
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerOpenMyScheduledCallsPageParams>} LogObject<callSchedulerOpenMyScheduledCallsPageParams>
 */
export function callSchedulerOpenMyScheduledCallsPage(params) {
    return { evid: 609, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerCancelCallbackRequest' event (evid: 610)
 *
 * Event description: User cancels their callback request
 *
 * @param {callSchedulerCancelCallbackRequestParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {GUID} queue_id - Id of the Answers queue the call will enter
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerCancelCallbackRequestParams>} LogObject<callSchedulerCancelCallbackRequestParams>
 */
export function callSchedulerCancelCallbackRequest(params) {
    return { evid: 610, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerKeepCallbackScheduled' event (evid: 611)
 *
 * Event description: User decides not to cancel their callback request by pressing "No, Keep It Scheduled" or by exiting out of the cancel window.
 *
 * @param {callSchedulerKeepCallbackScheduledParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerKeepCallbackScheduledParams>} LogObject<callSchedulerKeepCallbackScheduledParams>
 */
export function callSchedulerKeepCallbackScheduled(params) {
    return { evid: 611, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerAddToYourCalendar' event (evid: 612)
 *
 * Event description: User clicks the button to add the scheduled callback to their calendar.
 *
 * @param {callSchedulerAddToYourCalendarParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerAddToYourCalendarParams>} LogObject<callSchedulerAddToYourCalendarParams>
 */
export function callSchedulerAddToYourCalendar(params) {
    return { evid: 612, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerScheduledCallbackFailure' event (evid: 621)
 *
 * Event description: User failed to schedule a callback
 *
 * @param {callSchedulerScheduledCallbackFailureParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} local_time_zone - name of the user's time zone
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {DateTime} callback_datetime - the callback date and time chosen by the user
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerScheduledCallbackFailureParams>} LogObject<callSchedulerScheduledCallbackFailureParams>
 */
export function callSchedulerScheduledCallbackFailure(params) {
    return { evid: 621, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'callSchedulerLoadScheduleACallbackPage' event (evid: 622)
 *
 * Event description: Loading the “Schedule a Callback" page
 *
 * @param {callSchedulerLoadScheduleACallbackPageParams} params - The parameters for this event
 * @property {string} main_option_id - the id of the selected main option
 * @property {string} referral_name - referral
 * @property {string} session_id - Widget session ID
 * @property {string} context_platform - context_platform
 * @property {string} context_area - context_area
 * @property {string} sub_option_name - the name of the final sub option
 * @property {string} context_parenturl - context_parenturl
 * @property {string} kb_widget_state - describes the kb widget window state
 * @property {string} context_page_urlchunks - context_page_urlchunks
 * @property {string} context_uuid - context_uuid
 * @property {string} context_domain - context_domain
 * @property {string} sub_option_id - the id of the final sub option
 * @property {string} context_page_queryparams - context_page_queryparams
 * @property {string} user_experience - The widget experience that is being displayed to the user
 * @property {string} context_page_toplevelroute - context_page_toplevelroute
 * @property {string} main_option_name - the name of the selected main option
 * @property {string} suggestion_id - the id of the suggestion received by the User Success Platform
 * @property {string} topic - topic of the request (e-mail only)
 * @property {string} lang - User's Answers language
 * @property {string} type - demo or callback
 * @property {string} conversation_id - id of the chatbot's conversation
 * @property {string} context_iframeurllist - context_iframeurllist
 * @property {string} context_msid - context_msid
 * @property {string} chatbot_state - describes the chatbot window state
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @property {number} context_page_numlevels - context_page_numlevels
 * @return {LogObject<callSchedulerLoadScheduleACallbackPageParams>} LogObject<callSchedulerLoadScheduleACallbackPageParams>
 */
export function callSchedulerLoadScheduleACallbackPage(params) {
    return { evid: 622, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'clickOnFeaturedArticleInHeaderHelpWidget' event (evid: 623)
 *
 * Event description: Events when clicking an article from the Featured Article section in 'my site' help widget .
 *
 * @param {clickOnFeaturedArticleInHeaderHelpWidgetParams} params - The parameters for this event
 * @property {string} item_id - Article ID
 * @property {number} feature_article_position - index of the featured article clicked
 * @property {string} source_name - widget name
 * @property {string} lang - Article language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<clickOnFeaturedArticleInHeaderHelpWidgetParams>} LogObject<clickOnFeaturedArticleInHeaderHelpWidgetParams>
 */
export function clickOnFeaturedArticleInHeaderHelpWidget(params) {
    return { evid: 623, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'viewFeaturedArticlesInHeaderHelpWidget' event (evid: 624)
 *
 * Event description: View event when opening the 'my site' help widget .
 *
 * @param {viewFeaturedArticlesInHeaderHelpWidgetParams} params - The parameters for this event
 * @property {string} source_name - widget name
 * @property {string} featured_articles_item_ids - Article IDs  for the featured article listed in the widget (1st position, 2nd position, 3rd position)
 * @property {string} featured_articles_lang - Article language
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<viewFeaturedArticlesInHeaderHelpWidgetParams>} LogObject<viewFeaturedArticlesInHeaderHelpWidgetParams>
 */
export function viewFeaturedArticlesInHeaderHelpWidget(params) {
    return { evid: 624, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'wixWidgetOpenAWidgetClient' event (evid: 662)
 *
 * Event description: The event is trigger when a widget is opened
 *
 * @param {wixWidgetOpenAWidgetClientParams} params - The parameters for this event
 * @property {string} referral_name
 * @property {Url} referral_url - where the widget is opened from (source page url)
 * @property {string} parent_name
 * @property {string} current_platform - current_platform - where that chat is opened from currently { Editor, Biz manager, Domain page .... }
 * @property {string} source_name - source name
 * @property {string} module_name - first used module (home, chat, contact form, etc)
 * @property {string} lang - answer lang
 * @property {string} open_method - open method (api (automatically),click (user click),agent)
 * @property {string} parent_url
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<wixWidgetOpenAWidgetClientParams>} LogObject<wixWidgetOpenAWidgetClientParams>
 */
export function wixWidgetOpenAWidgetClient(params) {
    return { evid: 662, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'listenToRecordedCall' event (evid: 702)
 *
 * Event description: recorded call is being listened to by a user in Answers
 *
 * @param {listenToRecordedCallParams} params - The parameters for this event
 * @property {string} ticket_id - the ticket id
 * @property {GUID} uuid - the user who listened to the call
 * @property {GUID} answers_uuid - user id in answers users
 * @property {string} lang - answers languages
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<listenToRecordedCallParams>} LogObject<listenToRecordedCallParams>
 */
export function listenToRecordedCall(params) {
    return { evid: 702, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'appClickOnScreenshareFromACallTicket' event (evid: 703)
 *
 * Event description: Agent clicks on the link inside the ticket's custom fields in order to record the user's screen realtime during a call
 *
 * @param {appClickOnScreenshareFromACallTicketParams} params - The parameters for this event
 * @property {string} ticket_id - the ticket id
 * @property {GUID} customer_uuid - Caller uuid
 * @property {GUID} callid - the call id
 * @property {string} lang - answers languages
 * @property {GUID} agent_uuid - the agent who clicked on the recording link
 * @property {GUID} agent_id - agent_id
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<appClickOnScreenshareFromACallTicketParams>} LogObject<appClickOnScreenshareFromACallTicketParams>
 */
export function appClickOnScreenshareFromACallTicket(params) {
    return { evid: 703, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'screenshareLinkWasEnabledForACallLabelEvent' event (evid: 704)
 *
 * Event description: Screenshare link option is enabled or disabled for a specific call --> meaning - this call is assigned to an AB test group A or B
 *
 * @param {screenshareLinkWasEnabledForACallLabelEventParams} params - The parameters for this event
 * @property {string} ticket_id - the ticket id
 * @property {string} label_name - {A - no link was added ,B - the link was added}
 * @property {GUID} customer_uuid - Caller uuid
 * @property {GUID} callid - the call id
 * @property {string} lang - answers languages
 * @property {GUID} agent_id - agent_id
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<screenshareLinkWasEnabledForACallLabelEventParams>} LogObject<screenshareLinkWasEnabledForACallLabelEventParams>
 */
export function screenshareLinkWasEnabledForACallLabelEvent(params) {
    return { evid: 704, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'abTestConductionCheckEvent' event (evid: 705)
 *
 * Event description: Checking perti conduction value assigned to the user
 *
 * @param {abTestConductionCheckEventParams} params - The parameters for this event
 * @property {string} petri_conduciton_value - raw label value from Petri
 * @property {boolean} is_b - checking if petri_conduciton_value = b
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<abTestConductionCheckEventParams>} LogObject<abTestConductionCheckEventParams>
 */
export function abTestConductionCheckEvent(params) {
    return { evid: 705, src: 4, endpoint: 'ans_bi', params: params };
}
/**
 * A function to create a log object for the 'agentDeclinesCall' event (evid: 706)
 *
 * Event description: Agent clicks the decline button of a call reserve attempt
 *
 * @param {agentDeclinesCallParams} params - The parameters for this event
 * @property {GUID} tenant_id - ID of the answers tenant
 * @property {GUID} call_id - The ID of the declined call
 * @property {GUID} agent_id - The performing agent ID
 * @property {string} __cookies_prefix__wixLanguage - ignore_lng
 * @return {LogObject<agentDeclinesCallParams>} LogObject<agentDeclinesCallParams>
 */
export function agentDeclinesCall(params) {
    return { evid: 706, src: 4, endpoint: 'ans_bi', params: params };
}
//# sourceMappingURL=index.js.map